module.exports = __webpack_public_path__ + "static/media/kv-ja.ec3452c5.jpg";